module.exports = __webpack_public_path__ + "img/img_oms_brand@3x.2170881b.png";